import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { getTrackByFn } from '@y42/angular/util';
import { OperatorEnum } from '@y42/json-schema';
import { SelectOption } from '@y42/util/select-option';
import { operationInputDefaultOperatorOptions } from './operation-input-default-operator-options';

@Component({
  selector: 'y42-operation-input-operator-form-control[operatorControl]',
  templateUrl: './operation-input-operator-form-control.component.html',
  styleUrls: ['../operation-input-shared.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OperationInputOperatorFormControlComponent {
  @Input() operatorControl!: FormControl<OperatorEnum | undefined>;
  @Input() operatorOptions?: Array<SelectOption<OperatorEnum>>;

  readonly defaultOperatorOptions: Array<SelectOption<OperatorEnum>> = operationInputDefaultOperatorOptions;

  readonly trackByValueProp = getTrackByFn<SelectOption<OperatorEnum>>('value');
}
